import PropTypes from 'prop-types';
import React from 'react';

const Cart = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <polygon
      points="17.2 4.638 3.726 4.638 5.411 10.621 15.516 9.766 17.2 4.638"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="13.66"
      cy="15.4995"
      r="1"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="7.1499"
      cy="15.4995"
      r="1"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="3.726 4.638 2.884 2.501 1.2 2.501"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="5.411 10.621 4.568 13.186 13.832 13.186"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Cart.propTypes = {
  className: PropTypes.string,
};

export default Cart;
